import { SC } from '../helper/ServerCall'
import { pathSegment } from '../helper/queryString';

export const agencyTypeService = {
    getAgencyTypePagination,
    getAgencyType,
    storeAgencyType,
    updateAgencyType,
    deleteAgencyType
}

function getAgencyTypePagination(page, filter, sort, pageSize) {
    return SC.getCall('agencyType', { page, filter, sort, pageSize });
}

function getAgencyType(id) {
    return SC.getCall(`agencyType/${pathSegment(id)}`);
}

function storeAgencyType(data) {
    return SC.postCall(`agencyType`, data);
}

function updateAgencyType(id, data) {
    return SC.putCall(`agencyType/${pathSegment(id)}`, data);
}

function deleteAgencyType(id) {
    return SC.deleteCall(`agencyType/${pathSegment(id)}`);
}
